export default "__VITE_ASSET__EBxYbpEg__"